import { render, staticRenderFns } from "./ClassroomVideoSplitted.vue?vue&type=template&id=697364be&"
import script from "./ClassroomVideoSplitted.vue?vue&type=script&lang=js&"
export * from "./ClassroomVideoSplitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports